import { render, staticRenderFns } from "./StoragesList.vue?vue&type=template&id=0502cb1a&scoped=true&lang=true"
import script from "./StoragesList.vue?vue&type=script&lang=js"
export * from "./StoragesList.vue?vue&type=script&lang=js"
import style0 from "./StoragesList.vue?vue&type=style&index=0&id=0502cb1a&prod&lang=scss&scoped=true"
import style1 from "./StoragesList.vue?vue&type=style&index=1&id=0502cb1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0502cb1a",
  null
  
)

export default component.exports